import { GlobalService } from 'src/app/shared/service/global/global.service';

import { AutenticationService } from 'src/app/shared/service/autentication/autentication.service';
import { MasterDataManagementService } from 'src/app/shared/service/master-data-management/master-data-management.service';
import {
  Component,
  ContentChild,
  OnDestroy,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { KeyValue } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
let staticMenuData = require('./staticData.json');
@Component({
  selector: 'app-dashboard-sidebarmenu',
  templateUrl: './dashboard-sidebarmenu.component.html',
  styleUrls: ['./dashboard-sidebarmenu.component.css'],
})
export class DashboardSidebarmenuComponent implements OnInit, OnDestroy {
  programID: any;
  aclFlatList: any[] = [];
  aclTreeList: any[] = [];
  roleId: any;
  sessionUser: any;
  staticMenuData: any[] = [];
  unsubscribe$: Subject<boolean> = new Subject();

  constructor(
    route: Router,
    public masterDataService: MasterDataManagementService,
    public autenticationService: AutenticationService,
    public globalService: GlobalService,
  ) {
    this.sessionUser = this.autenticationService.getSessionUser();
    this.checkRouter(route);
    this.staticMenuData = staticMenuData;
  }

  ngOnInit(): void {
    this.masterDataService
      .getwebACLTriggerObs()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result) {
          this.getACLByRoleId();
        }
      });
    this.getACLByRoleId();
  }
  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
  collapsiableMenuItemJS() {
    var coll = document.getElementsByClassName('collapsible');
    var i;
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener('click', function () {
        this.parentElement.classList.toggle('active');
        //var content = this.nextElementSibling;
        //this.nextSibling.classList.toggle('show');
        if (this.nextSibling.classList.contains('show')) {
          this.nextSibling.classList.remove('show');
        } else {
          this.nextSibling.classList.add('show');
        }
      });
    }
  }

  checkRouter(route) {
    var scrollId: any;
    if (this.isExactMatch(route.url, 'welcome')) {
      scrollId = 'welcome';
    } else if (this.isExactMatch(route.url, 'projectConfig')) {
      scrollId = 'projectConfig';
    } else if (this.isExactMatch(route.url, 'cohortList')) {
      scrollId = 'cohortList';
    } else if (this.isExactMatch(route.url, 'geolocationList')) {
      scrollId = 'geolocationList';
    } else if (this.isExactMatch(route.url, 'userList')) {
      scrollId = 'userList';
    } else if (this.isExactMatch(route.url, 'zoneDistrictMappedList')) {
      scrollId = 'zoneDistrictMappedList';
    } else if (this.isExactMatch(route.url, 'branchSubdistrictMappedList')) {
      scrollId = 'branchSubdistrictMappedList';
    } else if (this.isExactMatch(route.url, 'zoneRegionBranchList')) {
      scrollId = 'zoneRegionBranchList';
    } else if (this.isExactMatch(route.url, 'catchmentAreaSetupList')) {
      scrollId = 'catchmentAreaSetupList';
    } else if (this.isExactMatch(route.url, 'designation')) {
      scrollId = 'designation';
    } else if (this.isExactMatch(route.url, 'designationHierarchy')) {
      scrollId = 'designationHierarchy';
    } else if (this.isExactMatch(route.url, 'supervisionHierarchy')) {
      scrollId = 'supervisionHierarchy';
    } else if (this.isExactMatch(route.url, 'accessControl')) {
      scrollId = 'accessControl';
    } else if (this.isExactMatch(route.url, 'staffMapping')) {
      scrollId = 'staffMapping';
    } else if (this.isExactMatch(route.url, 'staffTransfer')) {
      scrollId = 'staffTransfer';
    } else if (this.isExactMatch(route.url, 'followupQuestionnaireConfig')) {
      scrollId = 'followupQuestionnaireConfig';
    } else if (this.isExactMatch(route.url, 'swotConfiguration')) {
      scrollId = 'swotConfiguration';
    } else if (this.isExactMatch(route.url, 'homeVisitStepsConfig')) {
      scrollId = 'homeVisitStepsConfig';
    } else if (this.isExactMatch(route.url, 'homeVisitStepQuestionConfig')) {
      scrollId = 'homeVisitStepQuestionConfig';
    } else if (this.isExactMatch(route.url, 'graduationConfiguration')) {
      scrollId = 'graduationConfiguration';
    } else if (this.isExactMatch(route.url, 'committee-formation')) {
      scrollId = 'committee-formation';
    } else if (this.isExactMatch(route.url, 'meeting-activity-management')) {
      scrollId = 'meeting-activity-management';
    } else if (
      this.isExactMatch(route.url, 'approval-hierarchy-configuration')
    ) {
      scrollId = 'approval-hierarchy-configuration';
    } else if (this.isExactMatch(route.url, 'groups')) {
      scrollId = 'groups';
    } else if (this.isExactMatch(route.url, 'asset')) {
      scrollId = 'asset';
    } else if (this.isExactMatch(route.url, 'enterpriseCategory')) {
      scrollId = 'enterpriseCategory';
    } else if (this.isExactMatch(route.url, 'enterprise')) {
      scrollId = 'enterprise';
    } else if (this.isExactMatch(route.url, 'enterpriseMappings')) {
      scrollId = 'enterpriseMappings';
    } else if (this.isExactMatch(route.url, 'materials')) {
      scrollId = 'materials';
    } else if (this.isExactMatch(route.url, 'materialAndHomeVisit')) {
      scrollId = 'materialAndHomeVisit';
    } else if (this.isExactMatch(route.url, 'materialAndGroupVisit')) {
      scrollId = 'materialAndGroupVisit';
    } else if (this.isExactMatch(route.url, 'trainings')) {
      scrollId = 'trainings';
    } else if (this.isExactMatch(route.url, 'inputCatagory')) {
      scrollId = 'inputCatagory';
    } else if (this.isExactMatch(route.url, 'inputs')) {
      scrollId = 'inputs';
    } else if (this.isExactMatch(route.url, 'assetAndInputMapping')) {
      scrollId = 'assetAndInputMapping';
    } else if (this.isExactMatch(route.url, 'preRequisites')) {
      scrollId = 'preRequisites';
    } else if (this.isExactMatch(route.url, 'selectionCriterias')) {
      scrollId = 'selectionCriterias';
    } else if (this.isExactMatch(route.url, 'reasonType')) {
      scrollId = 'reasonType';
    } else if (this.isExactMatch(route.url, 'reason')) {
      scrollId = 'reason';
    } else if (this.isExactMatch(route.url, 'exclusion')) {
      scrollId = 'exclusion';
    } else if (this.isExactMatch(route.url, 'support-item')) {
      scrollId = 'support-item';
    } else if (this.isExactMatch(route.url, 'wealthRank')) {
      scrollId = 'wealthRank';
    } else if (this.isExactMatch(route.url, 'form-menu-mapping')) {
      scrollId = 'form-menu-mapping';
    } else if (this.isExactMatch(route.url, 'form')) {
      scrollId = 'form';
    } else if (this.isExactMatch(route.url, 'enterpriseSelectionReport')) {
      scrollId = 'enterpriseSelectionReport';
    } else if (this.isExactMatch(route.url, 'enterpriseGrowthReport')) {
      scrollId = 'enterpriseGrowthReport';
    } else if (this.isExactMatch(route.url, 'assetGrowthReport')) {
      scrollId = 'assetGrowthReport';
    } else if (this.isExactMatch(route.url, 'trainingReport')) {
      scrollId = 'trainingReport';
    } else if (this.isExactMatch(route.url, 'praReport')) {
      scrollId = 'praReport';
    } else if (this.isExactMatch(route.url, 'report/exclusionReport')) {
      scrollId = 'report/exclusionReport';
      //  this.isExactMatch(route.url, 'report/exclusionReport')
    } else if (this.isExactMatch(route.url, 'assetTransReport')) {
      scrollId = 'assetTransReport';
    } else if (this.isExactMatch(route.url, 'assetTransReportByGroup')) {
      scrollId = 'assetTransReportByGroup';
    } else if (this.isExactMatch(route.url, 'assetTransSummaryReport')) {
      scrollId = 'assetTransSummaryReport';
    } else if (this.isExactMatch(route.url, 'assetDiversificationReport')) {
      scrollId = 'assetDiversificationReport';
    } else if (this.isExactMatch(route.url, 'specialReport')) {
      scrollId = 'specialReport';
    } else if (this.isExactMatch(route.url, 'vsscReport')) {
      scrollId = 'vsscReport';
    } else if (this.isExactMatch(route.url, 'healthCareReport')) {
      scrollId = 'healthCareReport';
    } else if (this.isExactMatch(route.url, 'graduationReport')) {
      scrollId = 'graduationReport';
    } else if (this.isExactMatch(route.url, 'graduationReportGroupOne')) {
      scrollId = 'graduationReportGroupOne';
    } else if (this.isExactMatch(route.url, 'ssnpReport')) {
      scrollId = 'ssnpReport';
    } else if (
      this.isExactMatch(route.url, 'need-assessment-health-care-report')
    ) {
      scrollId = 'need-assessment-health-care-report';
    } else if (this.isExactMatch(route.url, 'participant-profile')) {
      scrollId = 'participant-profile';
    } else if (this.isExactMatch(route.url, 'checklist-field-setup')) {
      scrollId = 'checklist-field-setup';
    } else if (this.isExactMatch(route.url, 'checklist-field-data')) {
      scrollId = 'checklist-field-data';
    } else if (this.isExactMatch(route.url, 'checklist-action-plan')) {
      scrollId = 'checklist-action-plan';
    } else if (this.isExactMatch(route.url, 'team-action-plan')) {
      scrollId = 'team-action-plan';
    } else if (this.isExactMatch(route.url, 'supervision-action-plan-setup')) {
      scrollId = 'supervision-action-plan-setup';
    } else if (this.isExactMatch(route.url, 'action-plan-type-setup')) {
      scrollId = 'action-plan-type-setup';
    }
    // else if (this.isExactMatch(route.url, 'support')) {
    //   scrollId = 'support';
    // }
    else if (this.isExactMatch(route.url, 'groupVisitTopicSetup')) {
      scrollId = 'groupVisitTopicSetup';
    } else if (this.isExactMatch(route.url, 'send-approval-request')) {
      scrollId = 'send-approval-request';
    } else if (
      this.isExactMatch(route.url, 'waiting-for-my-approval/general-purchase')
    ) {
      scrollId = 'waiting-for-my-approval-general-purchase';
    } else if (
      this.isExactMatch(
        route.url,
        'waiting-for-my-approval/second-round-asset-support',
      )
    ) {
      scrollId = 'waiting-for-my-approval-second-round-asset-support';
    } else if (
      this.isExactMatch(route.url, 'my-approval-history/general-purchase')
    ) {
      scrollId = 'my-approval-history-general-purchase';
    } else if (
      this.isExactMatch(
        route.url,
        'my-approval-history/second-round-asset-support',
      )
    ) {
      scrollId = 'my-approval-history-second-round-asset-support';
    } else if (this.isExactMatch(route.url, 'correction')) {
      scrollId = 'correction';
    } else if (this.isExactMatch(route.url, 'audit-trail')) {
      scrollId = 'audit-trail';
    } else if (this.isExactMatch(route.url, 'cohort/asset-wise-growth-form')) {
      scrollId = 'cohort-asset-wise-growth-form';
    } else if (this.isExactMatch(route.url, 'report/baselineReport')) {
      scrollId = 'baselineReport';
    } else if (this.isExactMatch(route.url, 'cohort/create-group-visit')) {
      scrollId = 'create-group-visit';
    } else if (
      this.isExactMatch(route.url, 'report/market-linkage-initiative-report')
    ) {
      scrollId = 'market-linkage-initiative-report';
    } else if (this.isExactMatch(route.url, 'meal-findings')) {
      scrollId = 'meal-findings';
    } else if (this.isExactMatch(route.url, 'time-line-setup-for-user')) {
      scrollId = 'time-line-setup-for-user';
    } else if (
      this.isExactMatch(route.url, 'list-of-findings-acceptance-status')
    ) {
      scrollId = 'list-of-findings-acceptance-status';
    } else if (this.isExactMatch(route.url, 'list-of-findings-status')) {
      scrollId = 'list-of-findings-status';
    } else if (this.isExactMatch(route.url, 'list-of-findings')) {
      scrollId = 'list-of-findings';
    } else if (this.isExactMatch(route.url, 'list-of-finding-category')) {
      scrollId = 'list-of-finding-category';
    } else if (this.isExactMatch(route.url, 'list-of-finding-configuration')) {
      scrollId = 'list-of-finding-configuration';
    } else if (this.isExactMatch(route.url, 'enterprise-selection')) {
      scrollId = 'enterprise-selection';
    } else if (this.isExactMatch(route.url, 'asset-scanning')) {
      scrollId = 'asset-scanning';
    } else if (
      this.isExactMatch(route.url, 'enterprise-adaptation-planning-report')
    ) {
      scrollId = 'enterprise-adaptation-planning-report';
    } else if (this.isExactMatch(route.url, 'cohort/cohort-wise-configurable-feature')) {
      scrollId = 'cohort-wise-configurable-feature';
    } else if (this.isExactMatch(route.url, 'asset-scanning-report')) {
      scrollId = 'asset-scanning-report';
    } else if (this.isExactMatch(route.url, 'final-selection-report')) {
      scrollId = 'final-selection-report';
    } else if (this.isExactMatch(route.url, 'home-visit-display-configuration')) {
      scrollId = 'home-visit-display-configuration';
    } else if (this.isExactMatch(route.url, 'uvi-selection-report')) {
      scrollId = 'uvi-selection-report';
    } else if (this.isExactMatch(route.url, 'need-assesment-sp-cm-report')) {
      scrollId = 'need-assesment-sp-cm-report';
    } else if (this.isExactMatch(route.url, 'users-action-plan-report')) {
      scrollId = 'users-action-plan-report';
    } else if (
      this.isExactMatch(route.url, 'supervision-head-office-users-report')
    ) {
      scrollId = 'supervision-head-office-users-report';
    } else if (this.isExactMatch(route.url, 'man-boys-report')) {
      scrollId = 'man-boys-report';
    } else if (
      this.isExactMatch(route.url, 'selection-process-configuration')
    ) {
      scrollId = 'selection-process-configuration';
    } else if (
      this.isExactMatch(route.url, 'uvi-district-wise-income-configuration')
    ) {
      scrollId = 'uvi-district-wise-income-configuration';
    } else if (this.isExactMatch(route.url, 'yearly-calendar-setup')) {
      scrollId = 'yearly-calendar-setup';
    } else if (this.isExactMatch(route.url, 'holiday-calendar')) {
      scrollId = 'holiday-calendar';
    } else if (this.isExactMatch(route.url, 'holiday-list')) {
      scrollId = 'holiday-list';
    } else if (this.isExactMatch(route.url, 'holiday-event-reason-list')) {
      scrollId = 'holiday-event-reason-list';
    } else if (this.isExactMatch(route.url, 'mf-loan-transfer-write-off')) {
      scrollId = 'mf-loan-transfer-write-off';
    } else if (
      this.isExactMatch(route.url, 'mf-loan-transfer-write-off-report')
    ) {
      scrollId = 'mf-loan-transfer-write-off-report';
    } else {
      //scrollId = '';
    }

    // scroll to element.
    setTimeout(() => {
      this.scrollElement(scrollId);
    }, 2000);
  }

  escapeRegExpMatch(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  isExactMatch(str, match) {
    return new RegExp(`\\b${this.escapeRegExpMatch(match)}\\b`).test(str);
  }

  scrollElement(elemId) {
    // scrollIntoViewOptions Optional
    //  A Boolean or an object with the following options:
    //  {
    //    behavior: "auto"  | "instant" | "smooth",
    //    block:    "start" | "center" | "end" | "nearest",
    //    inline:    "start" | "center" | "end" | "nearest",
    //  }
    var element = document.getElementById(elemId);
    element.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  // WEB ACL
  public onCompare(
    _left: KeyValue<any, any>,
    _right: KeyValue<any, any>,
  ): number {
    return 1; // This is for asecding order
    // return -1; // // This is for dsecding order
  }

  getACLByRoleId(): any {
    this.globalService.showSpinner(true);
    this.roleId = this.sessionUser?.role?.role_id;
    this.programID = this.masterDataService.getProgramFromLocalStorage();

    this.masterDataService
      .getAllACLByRoleId(
        this.roleId,
        this.programID,
        this.masterDataService.getCohortFromLocalStorage() ?? null,
      )
      .subscribe(
        (result) => {
          if (result.status == 'ok') {
            //this.aclList = result.resultset;
            this.aclFlatList = result.resultset;

            // Sort menu list which have contain w_
            this.aclFlatList = this.aclFlatList.filter(function (obj) {
              //check if object value contains value you are looking for
              if (obj['menu_id'].includes('w_')) {
                //add this object to the filtered array
                return obj;
              }
            });

            //console.log(this.aclFlatList);
            this.autenticationService.setACLMenuInfo(this.aclFlatList);
            this.aclHirerchyDataReady(this.aclFlatList);
          }
        },
        (err) => {
          console.log(err);
        },
      );
  }

  aclHirerchyDataReady(list) {
    let finalArray = [];
    const arrayDummy = list;
    // Step: 1 => GroupBy Full list of array.
    var groupBy = this.groupBy(list, 'menu_id');
    //console.log(groupBy);
    // Step: 2 => For loop with GroupBy Object Length.
    for (let i = 0; i < Object.keys(groupBy).length; i++) {
      const element = Object.keys(groupBy)[i];
      // Step: 3 => Find Index  to check menuid(element) is on any submenu_id.
      const findIndex = arrayDummy.findIndex(
        (data) => data.submenu_id == element,
      );
      if (findIndex == -1) {
        // Step: 4 => If not then bind find its children
        var x = this.getNestedChildren(list, element);
        // Step: 5 => finnaly Push the result to a array and flat.
        finalArray.push(...x);
      }
    }
    //this.aclTreeList = finalArray;
    //console.log(finalArray);

    finalArray = finalArray.sort(this.globalService.dynamicSort('menu_order'));
    //console.log(finalArray);
    //this.aclTreeList = finalArray;

    this.aclTreeList = this.groupBy(finalArray, 'menu_id');
    //console.log(this.aclTreeList);
    this.globalService.showSpinner(false);

    setTimeout(() => {
      this.collapsiableMenuItemJS();
    }, 1000);
    // const entries = Object.entries(groupByFinal);
    // console.log(entries);

    //this.dataSourceBackUp = finalArray;
    //this.generateTreeGrid(this.aclTreeList);
    //this.loadACLModule(this.aclTreeList);
  }

  groupBy(arr, criteria) {
    const newObj = arr.reduce(function (acc, currentValue) {
      if (!acc[currentValue[criteria]]) {
        acc[currentValue[criteria]] = [];
      }
      acc[currentValue[criteria]].push(currentValue);
      return acc;
    }, {});
    return newObj;
  }

  getNestedChildren(arr, parent) {
    var out = [];
    for (var i in arr) {
      if (arr[i].menu_id == parent) {
        arr[i].actions.subModule = false;
        var children = this.getNestedChildren(arr, arr[i].submenu_id);

        if (children.length) {
          arr[i].children = children;
        }
        out.push(arr[i]);
      }
    }
    return out;
  }

  getMenuStaticData(menuId: string) {
    const findIndex = this.staticMenuData.findIndex(
      (data) => data.menu_id == menuId,
    );
    if (findIndex != -1) {
      // Found
      return this.staticMenuData[findIndex];
    } else {
      return false;
    }
  }

  menuClick(e) {
    //console.log(e);
  }
}
